import Validator from "../Utils/Validator";
import Services from "../Services";
import Notification from "../../../../global/js/Utils/ToasterNotification";
import _ from "lodash";
import {loader} from "../Utils/Loader";
import {delay} from "../Utils/Delay";
import ValidationErrorHandler from "../Utils/ValidationErrorHandler";
import ExceptionAxios from "../Utils/ExceptionAxios";

export default class Profile {
    main() {
        // this.initDatepicker()
        this.editProfileValidations()
        this.createAddressValidations()
        this.loadCities()
        this.setDefaultAddress()
        this.removeAddress()
        this.initShipmentAddresses()
    }

    editProfileValidations() {
        const $form = $(document).find('#edit-profile-form');
        if ($form.length > 0) {
            const $submit_button =  $form.find('button[type="submit"]');
            const validator = FormValidation.formValidation(
                document.getElementById('edit-profile-form'),
                {
                    locale: 'fa_IR',
                    fields: {
                        first_name: {
                            validators: {
                                notEmpty: {
                                    message: '«نام» خود را وارد کنید.'
                                },
                                regexp: {
                                    regexp: /^([ پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژ])+$/u,
                                    message: '«نام» باید به زبان فارسی و بدون عدد و علامت وارد شود.',
                                },
                                stringLength: {
                                    max: 100,
                                    message: '«نام» شما نباید بیشتر از 100 کاراکتر باشد.',
                                },
                            }
                        },
                        last_name: {
                            validators: {
                                notEmpty: {
                                    message: '«نام خانوادگی» خود را وارد کنید.'
                                },
                                regexp: {
                                    regexp: /^([ پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژ])+$/u,
                                    message: '«نام خانوادگی» باید به زبان فارسی و بدون عدد و علامت وارد شود.',
                                },
                                stringLength: {
                                    max: 100,
                                    message: '«نام خانوادگی» شما نباید بیشتر از 100 کاراکتر باشد.',
                                },
                            }
                        },
                        gender: {
                            validators: {
                                notEmpty: {
                                    message: '«جنسیت» خود را انتخاب کنید.'
                                }
                            }
                        },
                        national_code: {
                            validators: {
                                digits: {
                                    message: '«کد ملی» باید فقط حاوی عدد باشد.'
                                },
                                nationalCode: {
                                    message: '«کد ملی» وارد شده معتبر نیست.',
                                    callback: function (input) {
                                        if (Validator.nationalCode(input.value) || Services.isEmpty(input.value)) {
                                            return {
                                                valid: true
                                            }
                                        }
                                        if (input.value.length !== 10) {
                                            return {
                                                valid: false,
                                                message: '«کد ملی» باید 10 رقم باشد.',
                                            }
                                        }
                                        return {
                                            valid: false,
                                            message: '«کد ملی» وارد شده معتبر نیست.',
                                        }
                                    }
                                }
                            }
                        },
                        email: {
                            validators: {
                                emailAddress: {
                                    message: '«ایمیل» وارد شده نادرست است.'
                                }
                            }
                        },
                        birthdate: {
                            validators: {
                                persianDate: {
                                    message: '«تاریخ» انتخاب شده نادرست است.',
                                    callback: function (input) {
                                        if (Validator.persianDate(input.value) || Services.isEmpty(input.value)) {
                                            return {
                                                valid: true
                                            }
                                        }
                                        return {
                                            valid: false,
                                            message: '«تاریخ» انتخاب شده معتبر نیست!',
                                        }
                                    }
                                }
                            }
                        },
                    },

                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            event: {
                                birthdate: 'blur change keyup',
                            }
                        }),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                        bootstrap: new FormValidation.plugins.Bootstrap({
                            rowSelector: function(field) {
                                // field is the field name
                                // ele is the field element
                                switch (field) {
                                    case 'first_name':
                                    case 'last_name':
                                    case 'mobile':
                                    case 'gender':
                                    case 'national_code':
                                    case 'email':
                                    case 'birthdate':
                                        return '.col-lg-6';

                                    default:
                                        return '.form-row';
                                }
                            }
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fas fa-check',
                            invalid: 'fas fa-times',
                            validating: 'fas fa-refresh',
                        }),
                        alias: new FormValidation.plugins.Alias({
                            nationalCode: 'callback',
                            persianDate: 'callback',
                        }),
                        fieldStatus: new FormValidation.plugins.FieldStatus({
                            onStatusChanged: function(areFieldsValid) {
                                if (areFieldsValid) {
                                    $submit_button.prop('disabled', false);
                                } else {
                                    $submit_button.prop('disabled', true);
                                }
                            }
                        }),
                    }
                }
            );
            validator.on('core.form.invalid', function(event) {
                Swal.mixin({
                    customClass: {
                        confirmButton: 'btn btn-danger',
                    }
                }).fire({
                    title: 'خطا در اطلاعات',
                    text: 'لطفا خطا های به وجود آمده را برطرف نمایید.',
                    icon: 'error',
                    confirmButtonText: 'متوجه شدم'
                })
            });
        }
    }

    createAddressValidations() {
        const $form = $(document).find('#create_address_form');
        if ($form.length > 0) {
            const $submit_button =  $form.find('button[type="submit"]');
            const validator = FormValidation.formValidation(
                document.getElementById('create_address_form'),
                {
                    locale: 'fa_IR',
                    fields: {
                        first_name: {
                            validators: {
                                notEmpty: {
                                    message: '«نام» خود را وارد کنید.'
                                },
                                regexp: {
                                    regexp: /^([ پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژ])+$/u,
                                    message: '«نام» باید به زبان فارسی و بدون عدد و علامت وارد شود.',
                                },
                                stringLength: {
                                    max: 100,
                                    message: '«نام» شما نباید بیشتر از 100 کاراکتر باشد.',
                                },
                            }
                        },
                        last_name: {
                            validators: {
                                notEmpty: {
                                    message: '«نام خانوادگی» خود را وارد کنید.'
                                },
                                regexp: {
                                    regexp: /^([ پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژ])+$/u,
                                    message: '«نام خانوادگی» باید به زبان فارسی و بدون عدد و علامت وارد شود.',
                                },
                                stringLength: {
                                    max: 100,
                                    message: '«نام خانوادگی» شما نباید بیشتر از 100 کاراکتر باشد.',
                                },
                            }
                        },
                        mobile: {
                            validators: {
                                notEmpty: {
                                    message: '«موبایل» خود را وارد کنید.'
                                },
                                mobile: {
                                    message: '«موبایل» وارد شده نامعتبر است.',
                                    callback: function (input) {
                                        if (Validator.mobile(input.value) || Services.isEmpty(input.value)) {
                                            return {
                                                valid: true
                                            }
                                        }
                                        return {
                                            valid: false,
                                            message: '«موبایل» وارد شده نامعتبر است.',
                                        }
                                    }
                                }
                            }
                        },
                        postal_code: {
                            validators: {
                                notEmpty: {
                                    message: '«کد پستی» خود را وارد کنید.'
                                },
                                digits: {
                                    message: '«کد پستی» باید فقط حاوی عدد باشد.'
                                },
                                stringLength: {
                                    max: 10,
                                    min: 10,
                                    message: '«کد پستی» شما باید 10 رقمی و بدون خط تیره (-) باشد.',
                                },
                            }
                        },
                        building_number: {
                            validators: {
                                notEmpty: {
                                    message: '«پلاک» خود را وارد کنید.'
                                },
                                regexp: {
                                    regexp: /^([\d۱-۹])+$/u,
                                    message: '«پلاک» باید فقط حاوی عدد باشد.'
                                },
                                stringLength: {
                                    max: 10,
                                    message: '«پلاک» شما باید حداکثر 10 رقم باشد.',
                                },
                            }
                        },
                        province: {
                            validators: {
                                notEmpty: {
                                    message: '«استان» خود را انتخاب کنید.'
                                },
                            }
                        },
                        city: {
                            validators: {
                                notEmpty: {
                                    message: '«شهر» خود را انتخاب کنید.'
                                },
                            }
                        },
                        address: {
                            validators: {
                                notEmpty: {
                                    message: '«آدرس پستی» خود را وارد کنید.'
                                },
                                address: {
                                    message: '«آدرس پستی» انتخاب شده نادرست است.',
                                    callback: function (input) {
                                        if (Validator.address(input.value) || Services.isEmpty(input.value)) {
                                            return {
                                                valid: true
                                            }
                                        }
                                        return {
                                            valid: false,
                                            message: '«آدرس پستی» باید به زبان فارسی و میتواند حاوی اعداد و علامت (-) باشد.',
                                        }
                                    }
                                }
                            }
                        },
                    },

                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            event: {
                                birthdate: 'blur change keyup',
                            }
                        }),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                        bootstrap: new FormValidation.plugins.Bootstrap({
                            rowSelector: function(field) {
                                switch (field) {
                                    case 'first_name':
                                    case 'last_name':
                                    case 'mobile':
                                    case 'province':
                                    case 'city':
                                        return '.col-md-6.col-sm-12';
                                    case 'postal_code':
                                        return '.col-8';
                                    case 'building_number':
                                        return '.col-4';
                                    case 'address':
                                        return '.col-12';

                                    default:
                                        return '.form-row';
                                }
                            }
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fas fa-check',
                            invalid: 'fas fa-times',
                            validating: 'fas fa-refresh',
                        }),
                        alias: new FormValidation.plugins.Alias({
                            nationalCode: 'callback',
                            persianDate: 'callback',
                            address: 'callback',
                            mobile: 'callback',
                        }),
                        fieldStatus: new FormValidation.plugins.FieldStatus({
                            onStatusChanged: function(areFieldsValid) {
                                if (areFieldsValid) {
                                    $submit_button.prop('disabled', false);
                                } else {
                                    $submit_button.prop('disabled', true);
                                }
                            }
                        }),
                    }
                }
            );
            validator.on('core.form.invalid', function() {
                Swal.mixin({
                    customClass: {
                        confirmButton: 'btn btn-danger',
                    }
                }).fire({
                    title: 'خطا در اطلاعات',
                    text: 'لطفا خطا های به وجود آمده را برطرف نمایید.',
                    icon: 'error',
                    confirmButtonText: 'متوجه شدم'
                });
            });
            validator.on('core.form.valid', this.saveAddress);
        }
    }

    saveAddress() {
        const $form = $(document).find('#create_address_form');
        const $data = $form.serializeObject();
        loader().block('#modal_create_address .modal-content', {
            state: 'danger',
            opacity: 0.3,
            message: 'کمی صبر کنید...',
            borderRadius: 25
        })
        axios({
            url: $form.attr('action'),
            method: 'POST',
            data: $data
        }).then((res) => {
            Swal.fire({
                title: 'عملیات موفق',
                icon: 'success',
                html: 'آدرس با موفقیت ایجاد شد!',
                confirmButtonText: 'متوجه شدم'
            }).then((result) => {
                Services.Request.reload();
            })
            loader().unblock('#modal_create_address .modal-content')
        }).catch((error) => {
            const res = error.response;
            const $errors = res.data.errors
            if (res.status === 422) {
                Swal.mixin({
                    customClass: {
                        confirmButton: 'btn btn-danger',
                    },
                    width: '500px'
                }).fire({
                    title: 'خطا در درخواست',
                    icon: 'error',
                    html: ValidationErrorHandler.create($errors).toHtml().get(),
                    confirmButtonText: 'متوجه شدم'
                })
                loader().unblock('#modal_create_address .modal-content')
                return;
            }
            ExceptionAxios(res.data.messageBag, () => {
                Notification.error(3, 'خطای داخلی رخ داده است.');
            })
            loader().unblock('#modal_create_address .modal-content')
        })
    }

    setDefaultAddress() {
        const $btn_action = $(document).find('.js-btn-set-default-address');
        $btn_action.on('click', function () {
            const $this = $(this);
            Swal.fire({
                title: 'تایید عملیات',
                icon: 'question',
                html: 'آیا از انتخاب این آدرس به عنوان پیشفرض اطمینان دارید؟',
                confirmButtonText: 'بله',
                cancelButtonText: 'خیر',
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    loader().blockPage({
                        state: 'danger',
                        message: 'کمی صبر کنید...',
                        opacity: 0.3,
                    })
                    axios({
                        url: $this.data('action-url'),
                        method: 'PUT',
                    }).then((res) => {
                        Swal.fire({
                            title: 'عملیات موفق',
                            icon: 'success',
                            html: 'آدرس مورد نظر به آدرس پیشفرض تغییر کرد!',
                            confirmButtonText: 'متوجه شدم'
                        }).then((result) => {
                            Services.Request.reload();
                        })
                        loader().unblockPage()
                    }).catch((error) => {
                        const res = error.response;
                        ExceptionAxios(res.data.messageBag, () => {
                            Notification.error(3, 'خطای داخلی رخ داده است.');
                        })
                        loader().unblockPage()
                    })
                }
            })
        })
    }

    removeAddress() {
        const $btn_action = $(document).find('.js-btn-remove-address');
        $btn_action.on('click', function () {
            const $this = $(this);
            Swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-danger',
                    cancelButton: 'btn btn-secondary'
                }
            }).fire({
                title: 'تایید عملیات',
                icon: 'question',
                html: 'آیا از حذف این آدرس اطمینان دارید؟',
                confirmButtonText: 'بله',
                cancelButtonText: 'خیر',
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    loader().blockPage({
                        state: 'danger',
                        message: 'کمی صبر کنید...',
                        opacity: 0.3,
                    })
                    axios({
                        url: $this.data('action-url'),
                        method: 'DELETE',
                    }).then((res) => {
                        Swal.fire({
                            title: 'عملیات موفق',
                            icon: 'success',
                            html: 'آدرس مورد نظر حذف شد!',
                            confirmButtonText: 'متوجه شدم'
                        }).then((result) => {
                            Services.Request.reload();
                        })
                        loader().unblockPage()
                    }).catch((error) => {
                        const res = error.response;
                        ExceptionAxios(res.data.messageBag, () => {
                            Notification.error(3, 'خطای داخلی رخ داده است.');
                        })
                        loader().unblockPage()
                    })
                }
            })
        })
    }

    loadCities() {
        // Province Event
        const $instance = this;
        const $provinceSelect = $(document).find('select[name="province"]')
        $provinceSelect.on('change', function () {
            let $cities_cached;
            const $this = $(this);
            const $province = _.toNumber($this.val())
            if (isNaN($province)) {
                return;
            }
            loader().block('#modal_create_address .modal-content', {
                state: 'danger',
                opacity: 0.3,
                borderRadius: 25
            })
            if (($cities_cached = Profile.#getCitiesFromCache($province))) {
                $instance.reloadSelectCities($cities_cached, true)
                return;
            }
            axios({
                url: `/web/api/map/provinces/${$this.val()}/cities`,
                method: 'POST',
            }).then(({data}) => {
                const cities = data.data;
                if (!_.isUndefined(data) && _.has(data, 'data') && _.isArray(cities)) {
                    $instance.reloadSelectCities(cities, true)
                    Profile.#cacheCities($province, cities)
                }
            }).catch((error) => {
                Notification.error(3, 'مشکلی در دریافت شهرها بوجود آمده است.');
            })
        });
    }

    reloadSelectCities(cities, fromCache = false) {
        let options_elem = '<option selected value="" data-display="انتخاب نشده...">انتخاب نشده...</option>';
        const $citySelect = $(document).find('select[name="city"]')
        cities.forEach((item) => {
            options_elem = options_elem.concat(`<option value="${item.id}">${item.title}</option>`)
        })
        delay().time((fromCache ? 100 : 300)).handler(() => {
            loader().unblock('#modal_create_address .modal-content')
            $citySelect.closest('.custom-select-wrapper').find('.fv-plugins-icon').removeClass().addClass('fv-plugins-icon')
            $citySelect.closest('.custom-select-wrapper').next('.fv-plugins-message-container').html('')
            $citySelect.removeClass('is-valid is-invalid').html(options_elem).find(':first').prop('selected', true)
        }).fire()
    }

    static #getCitiesFromCache(province) {
        let cities = {};
        if (!_.has(window, '__cities_storage') || _.isUndefined(cities = window['__cities_storage'][province])) {
            return false;
        }
        return cities;
    }

    static #cacheCities(province, cities) {
        if (!_.has(window, '__cities_storage')) {
            return window['__cities_storage'] = {[province]: cities}
        }
        return window['__cities_storage'] = _.assign(window['__cities_storage'], {[province]: cities})
    }

    initDatepicker() {
        $("input[name='birthdate']").MdPersianDateTimePicker({
            targetTextSelector: "input[name='birthdate']",
            dateFormat: 'yyyy-MM-dd',
            isGregorian: false,
            yearOffset: 50,
            englishNumber: true,
            disableAfterToday: true
        });
    }

    initShipmentAddresses() {
        $("#btn-checkout-contact-location").on('click',function () {
            $(".checkout-contact-content").fadeOut('fast', function () {
                $(".checkout-address").fadeIn('fast');
            });
        });

        $("#cancel-change-address-btn").on('click',function () {
            $(".checkout-address").fadeOut('fast', function () {
                $(".checkout-contact-content").fadeIn('fast');
            });
        });
    }
}